import React from 'react';
import { Layout, Login, LoginClient, LoginCompany } from '../../pages/auth';
import { Route, Routes } from 'react-router-dom';
import { InscriptionClient } from '../../pages/client';

const Auth = () => {
    return (
        <div>
            <Routes>
                <Route element={<Layout />} >
                    <Route index element={<Login />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/loginCompany' element={<LoginCompany />} />
                    <Route path='/loginClient' element={<LoginClient />} />
                    <Route path='logup/:companyId' element={<InscriptionClient />} />

                </Route>
            </Routes>
        </div>
    );
};

export default Auth;